import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { BookNumbering } from 'src/app/beans/bookNumbering/bookNumbering';

@Injectable({
  providedIn: 'root'
})
export class BookNumberingHandler
{
    constructor
    (
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager
    ) {}

    async list( token: string, siteId: number )
    {      
        if ( !this._utils.checker().isValidText( token ) ) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if ( !this._utils.checker().isValidId( siteId ) ){
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        try
        {
          let response  = await this._request.bookNumbering().list( token, siteId ).toPromise()

          if ( this._error.hasError( response ) )
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response ) 
          }

          return response as BookNumbering[]

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

